import { createContext, useEffect, useState } from "react";
import API from "../api/api";

// Tipamos al usuario (podés ajustarlo según tu backend)
export interface IUser {
  id: number;
  email: string;
  nombre: string;
  codigo_usuario: string;
  puntos: number;
}


interface IUserContextType {
  user: IUser | null;
  login: (userData: IUser, token: string) => void;
  logout: () => void;
  refreshUser: () => Promise<void>; // 👈 NUEVO
}


// El contexto inicia en null
export const UserContext = createContext<IUserContextType | null>(null);

export const UserProvider = ({ children }: any) => {
  const [user, setUser] = useState<IUser | null>(null);

  // Restaurar sesión si hay token guardado
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    API.get("/auth/me")
      .then(res => setUser(res.data.user))
      .catch(() => localStorage.removeItem("token"));
  }, []);

  const refreshUser = async () => {
  try {
    const res = await API.get("/auth/me");
    setUser(res.data.user);
  } catch {
    localStorage.removeItem("token");
    setUser(null);
  }
};


  const login = (userData: IUser, token: string) => {
    localStorage.setItem("token", token);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("token");
    setUser(null);
  };

  return (
    <UserContext.Provider value={{ user, login, logout, refreshUser }}>
      {children}
    </UserContext.Provider>
  );
};
